import { FC } from "react";
import { useTranslation } from "react-i18next";
import { StaticInfoMessage } from "shared/components/feedback/InfoMessage/StaticInfoMessage";
import { Box, Text, tokens, VStack } from "shared/components/Spor";
import styled, { useTheme } from "styled-components";

const HastusMessage = styled(StaticInfoMessage)`
  min-width: 0;
  padding: ${tokens.default.size.spacing[2]};

  & > div {
    min-width: 0;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: start;
  }

  & p {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
`;

type MessagesFromHastusProps = {
  notes: string[];
};

/**
 * Displays messages from Plan/Hastus associated with a backup bus.
 */
export const MessagesFromHastus: FC<MessagesFromHastusProps> = ({ notes }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (notes.length === 0) {
    return (
      <Box padding="2">
        <Text variant="sm" fontWeight={400} color={theme.colorTextTertiary}>
          {t("Ingen meldinger fra Plan-avdelingen")}
        </Text>
      </Box>
    );
  }

  return (
    <VStack
      style={{
        width: "100%",
        minWidth: 0,
        padding: 0,
        alignItems: "stretch",
        gap: tokens.default.size.spacing[2],
      }}
    >
      {notes.map((note) => (
        <HastusMessage key={note} semantics="info" summary={note} />
      ))}
    </VStack>
  );
};
